import LayoutPayment from './LayoutPayment'

export default LayoutPayment
